var exports = {
  "Gw": "trailingSection__6oty9Z",
  "oP": "trailingSectionGrid__Ev_-8L",
  "ew": "ctaCards__gdMmLh",
  "wu": "ctaSectionIntro__a1UP-g",
};

module.exports = exports;
